<script>
    import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
    import { onMount } from "svelte";
    import Fa from "svelte-fa";
    import Button from "../ui/Button.svelte";
    import DateRequirements from "./DateRequirements.svelte";
    import Day from "./Day.svelte";

    export let date;
    export let locale = {
        weekdays: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
        months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        dateFormat: { year: 'numeric', month: '2-digit', day: '2-digit' }
    }
    export let blocked = {};
    export let valid = isAllowed(date);
    $: valid = isAllowed(date);
    $: isAvailable = checkAvailable(date);
    $: inBoundaries = checkBoundaries(date);
    export let id;
    export let min;
    export let max;
    
    let blockedTimes = [];

    const weekdays = [6, 0, 1, 2, 3, 4, 5];

    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    onMount(() => {
        focus = date?date:min?min:new Date();
        console.log(date);
        blockedTimes = unwrapBlocked();
        updateMonthView();
    })


    function unwrapBlocked() {
        let days = [];
        for (const [key, value] of Object.entries(blocked)) {
            if(key != id) {
                let day = value.start;
                while (day <= value.end) {
                    days.push(day);
                    day = day.addDays( 1);
                }
            }
        }
        return days.map(day => day.getTime())
    }

    let daysKeyboardHandler;
    let hasFocus;
    let preview = false;
    let focus = date?date:min?min:new Date();
    let days = [];

    function shiftDate(_focus, years, months, days, skipBlocked = false) {
        let keepGoing = true;
        while (keepGoing) {
            _focus.setFullYear(_focus.getFullYear() + years);
            _focus.setMonth(_focus.getMonth() + months);
            _focus.setDate(_focus.getDate() + days);
            keepGoing = skipBlocked?blockedTimes.includes(_focus.getTime()):false;
        }
        focus = _focus;
        updateMonthView();
    }


    function updateMonthView () {
        let firstDayOfMonth = new Date(focus.getFullYear(), focus.getMonth(), 1);
        let firstMonday = firstDayOfMonth;
        firstMonday = firstMonday.addDays(- weekdays[firstDayOfMonth.getDay()]);
        let lastSunday = firstMonday.addDays(41);
        
        let _days = [];
        let day = firstMonday;
        while (day <= lastSunday) {
            _days.push(day);
            day = day.addDays( 1);
        }
        days = _days;
    }

    function handleKeyUp(e) {
        e.preventDefault();
        if (e.key == "ArrowLeft") {
            shiftDate(focus, 0, 0, -1, true);
        }
        else if (e.key == "ArrowRight") {
            shiftDate(focus, 0, 0, 1, true);
        }
        else if (e.key == "ArrowUp") {
            shiftDate(focus, 0, 0, -7, true);
        }
        else if (e.key == "ArrowDown") {
            shiftDate(focus, 0, 0, 7, true);
        }
        else if (e.key == "Enter") {
            if (blockedTimes.includes(focus.getTime())) {
                console.log("Day is blocked");
                return
            }
            select(focus);
            console.log("selected: "+focus);
        }
    }

    function handleClick (day) {
        if (blockedTimes.includes(day.getTime())) {
            console.log("Day is blocked");
            return
        }
        focus = day;
        select(day);
        updateMonthView();
        daysKeyboardHandler.focus();
    }

    function handleHover (day) {
        if(preview && start) {
            end = day;
            valid = isAllowed(day);
        }
        else if (preview && blockedTimes.includes(day.getTime())) {
            valid = false;
        }
    }

    function select (day) {
        date = new Date(day.getFullYear(), day.getMonth(), day.getDate());
    }

    function isAllowed(day) {
        return checkAvailable(day) && checkBoundaries(day);
    }
    
    function checkAvailable(day) {
        return day?!blockedTimes.includes(day.getTime()):false;
    }

    function checkBoundaries(day) {
        if(min && day < min) {
            return false;
        } else if(max && day > max) {
            return false;
        } else {
            return true
        }
    }
</script>

<div class="picker">
    <div class="nav">
        <div class="year">
            <Button on:click={() => {shiftDate(focus, -1, 0, 0)}}>
                <Fa
                    icon={faArrowLeft}
                    slot="icon"
                />
            </Button>
            <span>
                {focus.getFullYear()}
            </span>
            <Button on:click={() => {shiftDate(focus, 1, 0, 0)}}>
                <Fa
                icon={faArrowRight}
                slot="icon"
                />
            </Button>
        </div>
        <div class="month">
            <Button on:click={() => {shiftDate(focus, 0, -1, 0)}}>
                <Fa
                icon={faArrowLeft}
                slot="icon"
                />
            </Button>
            <span>
                {locale.months[focus.getMonth()]}
            </span>
            <Button on:click={() => {shiftDate(focus, 0, 1, 0)}}>
                <Fa
                icon={faArrowRight}
                slot="icon"
                />
            </Button>
        </div>
    </div>
    <div
        class="days"
        class:focus={hasFocus}
        class:valid={valid}
    >
        <input class="days-keyboard-handler" on:keyup|preventDefault={handleKeyUp} on:focusin={() => {hasFocus=true}} on:focusout={() => {hasFocus=false}} bind:this={daysKeyboardHandler}>
        {#each locale.weekdays as weekday}
            <span class="weekday">
                {weekday}
            </span>
        {/each}
        {#each days as day, i}
            <Day bind:focus={focus} bind:selected={date} bind:blocked bind:id {day} column={i%7} on:click={(e) => handleClick(e.detail)} on:mouseover={(e) => handleHover(e.detail)}/>
        {/each}
    </div>
    
    <DateRequirements bind:available={isAvailable} bind:min bind:max bind:inBoundaries/>
</div>

<style>
    .picker {
        background-color: #F5F2EF;
        border-radius: 0.5rem;
        padding: 1rem;
        overflow: hidden;
    }

    .nav {
        display: flex;
        width: 100%;
        flex-direction: column;
    }

    .year,
    .month {
        display: flex;
        justify-content: space-between;
    }

    .year>span,
    .month>span {
        flex: 1;
        text-align: center;
    }

    .days {
        position: relative;
        display: grid;
        box-sizing: border-box;
        grid-template-rows: repeat(7, 1fr);
        grid-template-columns: repeat(7, 1fr);
        grid-template-areas: none;
        margin: 0 calc(((-100% / 7) + 2rem ) / 2);
        row-gap: 1px;
        column-gap: 1px;
        height: 100%;
        z-index: 1;
    }
    
    .days-keyboard-handler {
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 0;
        opacity: 0;
    }

    .weekday {
        text-align: center;
        display: block;
        line-height: 2rem;
        color: grey;
    }
</style>